<template>
  <div class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="content-box">
        <van-list
          class="list-container"
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          :immediate-check="false"
          @load="getList"
        >
          <div class="coupon-list con-wrp">
            <div v-for="item in list" :key="item.rid" class="coupon-item-wrp">
              <div class="coupon-item">
                <div class="img-box">
                  <van-image :width="transPxToRem(60)" :height="transPxToRem(52)" :src="effectCouponIcon" />
                </div>
                <div class="content">
                  <div class="coupon-name van-ellipsis">{{ item.coupon_name }}</div>
                  <div class="coupon-time">
                    <div>有效期：{{ item.start_time }}~</div>
                    <div>{{ item.end_time }}</div>
                  </div>
                </div>
                <van-image
                  class="effect-stamp"
                  :src="item.status === 2 ? usedCouponIcon : effectedCouponIcon"
                  :width="transPxToRem(60)"
                  :height="transPxToRem(60)"
                />
              </div>
              <ul class="des-up-block" v-if="item.isShowDes && item.desList.length > 0">
                <template v-for="(desItem, index) in item.desList" :key="index">
                  <li
                    v-if="desItem"
                    class="list-item"
                    :class="{ 'has-list-dot': item.desList.filter(d => d).length > 1 }"
                  >
                    {{ desItem }}
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </van-list>
        <van-empty
          v-if="list.length == 0 && !loading"
          image-size="240"
          image="https://i.xurl.cn/x_dsx_wxapp/empty/coupon.png"
          description="暂无优惠券"
        />
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, reactive } from 'vue'
import { Image as VanImage } from 'vant'
import effectCouponIcon from '@/assets/img/effect-coupon-icon.png'
import usedCouponIcon from '@/assets/img/coupon_stamp-use.png'
import effectedCouponIcon from '@/assets/img/coupon_stamp-effect.png'
import { transPxToRem } from '@/utils'
import { getMemberCouponList } from '@/api/coupon'

const pageParams = reactive({
  page: 1,
  pageSize: 20
})
// const postParams = ref({})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  list.value = []
  pageParams.page = 1
  finished.value = false
}
const getList = async () => {
  loading.value = true
  try {
    const resData = await getMemberCouponList({ ...pageParams, coupon_status: 100, coupon_type: 3 })
    list.value.push(
      ...resData.list.map(d => ({
        ...d,
        isShowDes: true,
        desList: d.remark ? [`备注：${d.remark}`] : []
      }))
    )
    pageParams.page++
    finished.value = list.value.length >= +resData.total
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    reset()
    getList()
  } finally {
    refreshing.value = false
  }
}
onMounted(() => {
  try {
    getList()
  } catch (e) {
    console.log(e)
  }
})
</script>
<style scoped lang="less">
.page-container {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: calc(5px + env(safe-area-inset-bottom));
  overflow: auto;
  .content-box {
    padding-bottom: 60px;
    .coupon-list {
      .coupon-item-wrp {
        background-color: #fff;
        margin: 12px;
        border-radius: 8px;
        overflow: hidden;
      }
      .coupon-item {
        display: flex;
        align-items: center;
        position: relative;
        color: #999999;
        box-shadow: 0px 2px 6px 0px rgba(34, 34, 34, 0.04);
        border-radius: 8px;

        .img-box {
          padding: 22px 16px;
          border-right: 1px dashed #efefef;
        }
        .content {
          padding: 0 16px;
          .coupon-name {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            height: 22px;
            margin-bottom: 10px;
            max-width: 230px;
          }
          .coupon-time {
            color: #999999;
            font-size: 12px;
          }
        }
        .effect-stamp {
          position: absolute;
          right: 12px;
        }
      }
      .des-up-block {
        background: #ffffff;
        color: #999;
        font-size: 12px;
        padding: 8px 12px;
        border-radius: 0px 0px 8px 8px;
        .list-item {
          height: 18px;
          line-height: 18px;
          position: relative;
        }
        .has-list-dot {
          &::before {
            position: absolute;
            content: '.';
            display: inline-block;
            left: -5px;
            top: -4px;
          }
        }
      }
    }
  }
}
</style>
